export const goToAdminPage = (domain, redirect) => {
  let DOMAIN = `https://${domain}`;

  if (document.location.hostname === 'localhost' || document.location.hostname === '127.0.0.1') {
    DOMAIN = 'http://localhost:3001';
  }

  const URL = `${DOMAIN}/login-through?accessToken=${localStorage.getItem('authorizationToken')}&redirect=${redirect}`;
  window.open(URL, '_blank');
};
